module.exports = __webpack_public_path__ + "img/Logo_IC_dezembro_vermelho_semfundo.3ba29c4c.svg";